module.exports = __webpack_public_path__ + "img/p-05.1aaac5f5.webp";